export const CONNECT_AMMOLITE = 'CONNECT_AMMOLITE';
export const UPDATE_AMMOLITE = 'UPDATE_AMMOLITE';
export const RESET_AMMOLITE_STATE = 'RESET_AMMOLITE_STATE';
